import { useGameStore } from "../game/useGameStore";
import { KATAS } from "../game/katas";

const NODE_COLOR_UNLOCKED = "#ffdd00";
const NODE_COLOR_LOCKED   = "#444";
const LINE_COLOR_UNLOCKED = "#ffaa00";
const LINE_COLOR_LOCKED   = "#333";

export function SkillTreeScreen() {
  const setPhase     = useGameStore((s) => s.setPhase);
  const unlockedKatas = useGameStore((s) => s.unlockedKatas);
  const activeKata   = useGameStore((s) => s.activeKata);
  const setActiveKata = useGameStore((s) => s.setActiveKata);

  function openDemo(id: number) {
    setActiveKata(id);
    setPhase("kata");
  }

  return (
    <div style={overlay}>
      <h2 style={titleStyle}>DOJO KATA</h2>

      {/* Vertical tree */}
      <div style={treeContainer}>
        {KATAS.map((kata, idx) => {
          const unlocked = unlockedKatas.includes(kata.id);
          const isActive = activeKata === kata.id;
          const prev = idx > 0 ? KATAS[idx - 1] : null;
          const prevUnlocked = prev ? unlockedKatas.includes(prev.id) : true;

          return (
            <div key={kata.id} style={nodeWrapper}>
              {/* Connector line from previous node */}
              {idx > 0 && (
                <div style={{
                  ...connector,
                  background: prevUnlocked && unlocked ? LINE_COLOR_UNLOCKED : LINE_COLOR_LOCKED,
                }} />
              )}

              <button
                onClick={() => unlocked && openDemo(kata.id)}
                disabled={!unlocked}
                style={{
                  ...nodeBtn,
                  borderColor: unlocked ? NODE_COLOR_UNLOCKED : NODE_COLOR_LOCKED,
                  color:       unlocked ? NODE_COLOR_UNLOCKED : "#666",
                  background:  isActive  ? "#3a2800" : "transparent",
                  cursor:      unlocked  ? "pointer" : "default",
                  opacity:     unlocked  ? 1 : 0.55,
                }}
              >
                <span style={{ fontSize: 18, display: "block" }}>
                  {unlocked ? kata.nameJP : "🔒"}
                </span>
                <span style={{ fontSize: 13, letterSpacing: 1 }}>
                  {unlocked ? kata.name : "???"}
                </span>
                {unlocked && (
                  <span style={{ fontSize: 10, opacity: 0.7, marginTop: 2, display: "block" }}>
                    {kata.waza}
                  </span>
                )}
                {!unlocked && (
                  <span style={{ fontSize: 10, opacity: 0.5, marginTop: 2, display: "block" }}>
                    Complete rhythm seq {kata.id}
                  </span>
                )}
              </button>
            </div>
          );
        })}
      </div>

      <button onClick={() => setPhase("menu")} style={backBtn}>
        Back
      </button>
    </div>
  );
}

// ─── Styles ───────────────────────────────────────────────────────────────────

const overlay: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "flex-start",
  paddingTop: 40,
  color: "white",
  fontFamily: "monospace",
  background: "linear-gradient(180deg, #0a0500 0%, #1a0d00 100%)",
  overflowY: "auto",
};

const titleStyle: React.CSSProperties = {
  fontSize: 28,
  margin: "0 0 32px 0",
  letterSpacing: 6,
  color: "#ffdd88",
};

const treeContainer: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  gap: 0,
  width: "100%",
  maxWidth: 340,
};

const nodeWrapper: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  width: "100%",
};

const connector: React.CSSProperties = {
  width: 2,
  height: 28,
};

const nodeBtn: React.CSSProperties = {
  width: "100%",
  padding: "14px 20px",
  border: "2px solid",
  borderRadius: 10,
  textAlign: "center",
  fontFamily: "monospace",
  transition: "border-color 0.2s, background 0.2s",
};

const backBtn: React.CSSProperties = {
  marginTop: 36,
  marginBottom: 24,
  padding: "12px 32px",
  fontSize: 15,
  fontFamily: "monospace",
  cursor: "pointer",
  border: "1px solid #555",
  background: "transparent",
  color: "#aaa",
  borderRadius: 6,
  letterSpacing: 2,
};
